import { render, staticRenderFns } from "./Kicks.vue?vue&type=template&id=47f65702&scoped=true"
import script from "./Kicks.vue?vue&type=script&lang=js"
export * from "./Kicks.vue?vue&type=script&lang=js"
import style0 from "./Kicks.vue?vue&type=style&index=0&id=47f65702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f65702",
  null
  
)

export default component.exports